import React, { useState, useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { useTestContext } from "../context/TestContext";

// imports
import UIWrapper from "../components/UIWrapper";
import NavigationTracker from "../components/NavigationTracker";
import NavigationBar from "../components/NavigationBar";
import TitleText from "../components/TitleText";
import Pagination from "../components/Pagination";
const ProductCard = lazy(() => import("../components/ProductCard"));

const LabSpecific = () => {
  const location = useLocation();
  const { fetchBrandProducts, brandProducts, brandPaginationInfo } =
    useTestContext();
  const [currentPage, setCurrentPage] = useState(1);

  // Extract the brand name from the path
  const parts = location.pathname.split("/");
  const result = parts[2];
  const formattedBrandName = result
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  // Extract the last endpoint from the path
  const lastEndpoint = location.pathname.split("/").filter(Boolean).pop();

  const navigationLinks = [
    { title: "Blood", link: `/lab/${result}/Blood` },
    { title: "Liver", link: `/lab/${result}/Liver` },
    { title: "Heart", link: `/lab/${result}/Heart` },
    { title: "Kidney", link: `/lab/${result}/Kidney` },
    { title: "Bones", link: `/lab/${result}/Bones` },
  ];

  // Scroll to top with smooth behavior when filterData changes (or on initial mount)
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [formattedBrandName, lastEndpoint, currentPage]);

  useEffect(() => {
    fetchBrandProducts(formattedBrandName, lastEndpoint, currentPage);
  }, [formattedBrandName, lastEndpoint, currentPage]);
  

  return (
    <UIWrapper>
      <div className="w-full h-fit p-[3%] lg:p-[2%] space-y-[5%] lg:space-y-[1%]">
        <NavigationTracker
          endpoint={formattedBrandName + " - " + lastEndpoint}
        />
        <div className="w-full h-fit flex justify-center items-center px-[2%] lg:px-[25%] mb-[10%]">
          <NavigationBar navigationLinks={navigationLinks} />
        </div>
        <div className="w-full h-fit flex flex-col justify-start items-center space-y-[5%] lg:space-y-[2%]">
          <TitleText text={formattedBrandName + " " + "Tests"} />
          <div className="w-full h-[75vh] lg:h-fit grid grid-cols-1 lg:grid-cols-3 gap-x-0 gap-y-5 lg:gap-y-7 mx-auto justify-items-center px-[5%] lg:px-[7.5%] mb-[3%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
            <Suspense
              fallback={
                <div className="w-full h-fit flex justify-center items-center">
                  <p className="font-normal text-[1vw] text-textSecondaryColor">
                    Loading brand products...
                  </p>
                </div>
              }
            >
              {brandProducts?.map((test, index) => (
                <ProductCard key={index} data={test} />
              ))}
            </Suspense>
          </div>
        </div>
        <div className="w-full h-ft flex justify-center items-center">
          {currentPage < brandPaginationInfo?.totalPages ? (
            <button
              className="font-normal text-[4vw] lg:text-[1vw] text-primaryColor underline"
              onClick={() => setCurrentPage((prev) => prev + 1)}
            >
              View more
            </button>
          ) : (
            <span className="font-normal text-[1vw] text-textSecondaryColor">
              No more products to load.
            </span>
          )}
        </div>
        {/* <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={brandPaginationInfo?.totalPages}
        /> */}
      </div>
    </UIWrapper>
  );
};

export default LabSpecific;
